// Auto-generated by scripts/generate-registry.mjs from packages/modules/petal_glow_table_lamp/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const petal_glow_table_lamp: ModuleSchema = {
  "id": "petal_glow_table_lamp",
  "uniqueId": "B3D_FISDR",
  "createdAt": "2026-10-20T03:41:17.546Z",
  "updatedAt": "2026-10-23T11:53:49.989Z",
  "label": "Petal Glow Lamp",
  "description": "A conical petal-window desk lamp with a ribbed shade and tapered square LED base.",
  "category": "lamp_assembly",
  "tags": [
    "petal-glow-table-lamp"
  ],
  "sliders": [
    {
      "key": "baseWidth",
      "label": "Base Diameter",
      "min": 80,
      "max": 140,
      "default": 110,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "baseHeight",
      "label": "Base Height",
      "min": 40,
      "max": 140,
      "default": 140,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1
      ]
    },
    {
      "key": "baseChamferHeight",
      "label": "Base Bottom Chamfer",
      "min": 0,
      "max": 30,
      "default": 10,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "baseFuzzyDepth",
      "label": "Bề mặt fuzzy",
      "min": 0,
      "max": 1,
      "default": 0,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "shadeHeight",
      "label": "Shade Height",
      "min": 40,
      "max": 180,
      "default": 70,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "shadeDiameter",
      "label": "Shade Diameter",
      "min": 60,
      "max": 240,
      "default": 200,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "outerRibsCount",
      "label": "Gân ngoài đứng (Số nan)",
      "min": 0,
      "max": 60,
      "default": 20,
      "step": 1,
      "unit": "nan",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "outerRibWidth",
      "label": "Bề rộng gân ngoài",
      "min": 0.2,
      "max": 3,
      "default": 0.5,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "outerRibHeight",
      "label": "Độ nhô gân ngoài",
      "min": 0.2,
      "max": 3,
      "default": 0.5,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "outerRibFade",
      "label": "Độ vuốt mờ 2 đầu (Fade)",
      "min": 2,
      "max": 30,
      "default": 10,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "petal_ribbed_shade",
      "label": "Petal-Ribbed Shade",
      "default": "#f5ead7",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "e27_base",
      "label": "E27 Round Base",
      "default": "#d7d2c6",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "base_screws",
      "label": "4x E27 Base Screws",
      "default": "#7b7368",
      "targetGroupIds": [
        2
      ]
    }
  ],
  "objects": [
    {
      "id": "petal_glow_lamp",
      "label": "Petal Glow Lamp",
      "name": "Petal Glow Lamp",
      "color": "#f5ead7",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "petal_ribbed_shade",
          "label": "Petal-Ribbed Shade",
          "name": "Petal-Ribbed Shade",
          "groupId": 0,
          "colorKey": "petal_ribbed_shade",
          "defaultColor": "#f5ead7",
          "assembled_z_offset": 0,
          "exploded_z_offset": 45,
          "export_stl": true
        },
        {
          "id": "e27_base",
          "label": "E27 Round Base",
          "name": "E27 Round Base",
          "groupId": 1,
          "colorKey": "e27_base",
          "defaultColor": "#d7d2c6",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        },
        {
          "id": "base_screws",
          "label": "4x E27 Base Screws",
          "name": "4x E27 Base Screws",
          "groupId": 2,
          "colorKey": "base_screws",
          "defaultColor": "#7b7368",
          "assembled_z_offset": 0,
          "exploded_z_offset": -18,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full Lamp Assembly",
      "groupId": -1
    },
    {
      "id": "shade",
      "label": "Download STL - Shade Only",
      "groupId": 0
    },
    {
      "id": "base",
      "label": "Download STL - Base Only",
      "groupId": 1
    }
  ]
};
